import axios from 'axios';

const STORAGE_KEY = 'nexflow.preview_session';

/**
 * Read the current preview session from localStorage.
 * Shape: { user_id, name, email, role, started_at } or null.
 */
export const getPreviewSession = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
};

export const setPreviewSession = (session) => {
  if (session) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(session));
  } else {
    localStorage.removeItem(STORAGE_KEY);
  }
  // Notify any listeners in the same tab
  window.dispatchEvent(new CustomEvent('nexflow:preview-change'));
};

export const clearPreviewSession = () => setPreviewSession(null);

/**
 * Install an axios request interceptor that adds the X-Preview-As-User-Id header
 * whenever a preview session is active in localStorage.
 * Safe to call multiple times — duplicate registrations are guarded.
 */
let _installed = false;
export const installPreviewInterceptor = () => {
  if (_installed) return;
  _installed = true;
  // Auth endpoints should never run under impersonation — strip the header so
  // login/register/refresh aren't blocked by the read-only middleware if a stale
  // preview session is hanging around in localStorage.
  const AUTH_PATHS = ['/api/auth/login', '/api/auth/register', '/api/auth/refresh', '/api/auth/logout', '/api/admin/preview/stop'];
  axios.interceptors.request.use((config) => {
    const session = getPreviewSession();
    if (session?.user_id) {
      const url = config.url || '';
      const isAuth = AUTH_PATHS.some((p) => url.includes(p));
      if (!isAuth) {
        config.headers = config.headers || {};
        config.headers['X-Preview-As-User-Id'] = session.user_id;
      }
    }
    return config;
  });
};

export const isPreviewActive = () => !!getPreviewSession();
